import { useId, useState } from 'react';

import { SimpleModal } from '../../../shared/SimpleModal';

import { AddTreeReplacementContent } from './AddTreeReplacementContent';
import { EditTreeReplacementContent } from './EditTreeReplacementContent';
import type { TreeReplacementView } from './tree-replacement-view';
import { TreeReplacementModalFooter } from './TreeReplacementModalFooter';

/** The one modal for tree replacements; adding and editing are its content. It
 *  can't be dismissed while a save is in flight. */
export function TreeReplacementModal({
  workshopId,
  view,
  onClose,
}: {
  workshopId: string;
  view: TreeReplacementView;
  onClose: () => void;
}) {
  const formId = useId();
  const [saving, setSaving] = useState(false);
  const title =
    view.mode === 'add' ? 'Add tree replacement' : `Edit replacement for ${view.customerName}`;

  return (
    <SimpleModal
      open
      onClose={saving ? () => undefined : onClose}
      title={title}
      footer={
        <TreeReplacementModalFooter
          mode={view.mode}
          formId={formId}
          saving={saving}
          onCancel={onClose}
        />
      }
    >
      {view.mode === 'add' ? (
        <AddTreeReplacementContent
          workshopId={workshopId}
          formId={formId}
          onSavingChange={setSaving}
          onDone={onClose}
        />
      ) : (
        <EditTreeReplacementContent
          workshopId={workshopId}
          treeReplacementId={view.treeReplacementId}
          formId={formId}
          onSavingChange={setSaving}
          onDone={onClose}
        />
      )}
    </SimpleModal>
  );
}
